module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cross-profile-box"
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disabled,
      "content": _vm.tooltip
    }
  }, [_c('div', {
    class: ("square square-color-tier-" + _vm.roundedPercentage)
  }, [_c('span', {
    staticClass: "square-text"
  }, [_vm._v(_vm._s(_vm.roundedPercentage))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ff4a790","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/charts/CrossPlatformEngagementCellBlock.vue
// module id = 3175
// module chunks = 3